var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.6084H7.75H10.75H11.5V2.3584V3.38965C11.5 4.33652 11.3156 5.2584 10.9719 6.1084H14H15.25H16V6.8584V9.3584V10.1084H15.5V11.3584V12.1084H14.75V13.3584V14.1084H14V14.8584V15.6084H13.25H12H8.5H8.12187H7.89375L7.70625 15.4834L7.39062 15.274L5 13.6803V11.8771L8.22188 14.0271L8.34688 14.1115H8.49687H11.9969H12.4969V13.3615V12.6115H13.2469V11.3615V10.6115H13.9969V9.36152V8.61152H14.4969V7.61152H13.9969H9.74375H8.38437L9.10938 6.46152C9.68125 5.55527 10 4.4959 10 3.38965V3.1084H8.5V3.38965C8.5 4.9459 7.65 6.37715 6.28438 7.1209L6.14062 7.19902L5.55937 7.51465L5.39062 7.60527H5.2H5.125H5V6.10527H5.00938L5.42188 5.88027L5.56563 5.80215C6.45 5.32402 7 4.3959 7 3.38965V2.3584V1.6084ZM4 6.6084V15.6084H0V6.6084H4Z",
    fill: "#1A1818",
    fillOpacity: 0.8
  })));
};
export default SvgThumbsUp;